import { render } from "./DemoView.vue?vue&type=template&id=4b864eee"
import script from "./DemoView.vue?vue&type=script&lang=js"
export * from "./DemoView.vue?vue&type=script&lang=js"

import "./DemoView.vue?vue&type=style&index=0&id=4b864eee&lang=scss"

import exportComponent from "C:\\Users\\cheew\\OneDrive\\Desktop\\CE4172\\drum\\drum-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__